import { useMemo } from 'react';

import { ActionValidator } from '@bonusly/common-action-input';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

interface UseValidatorOptions {
	balanceAdjustment?: number;
	balanceOverride?: number;
}

export const useValidator = ({ balanceAdjustment = 0, balanceOverride }: UseValidatorOptions = {}) => {
	const user = useCurrentUser();
	const company = useCurrentCompany();

	return useMemo(() => {
		const requireHashtag = (() => {
			const hashtags = company.company_hashtags ? company.company_hashtags.map((hashtag) => hashtag.slice(1)) : [];

			switch (company.hashtagging_mode) {
				case 'at_least_one_company_hashtag':
					return hashtags;

				case 'at_least_one_hashtag':
					return true;

				default:
					return false;
			}
		})();

		return new ActionValidator({
			requireAmount: !company.zero_point_bonuses,
			requireRecipient: true,
			requireBalance: balanceOverride ?? user.giving_balance + balanceAdjustment,
			requireHashtag,
			requirePositiveAmount: !company.zero_point_bonuses,
		});
	}, [balanceAdjustment, balanceOverride, company, user]);
};
